import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteConsignmentOrderRefund,
  getConsignmentOrderRefundByOrderId,
} from '../../../../appRedux/actions';
import { useParams } from 'react-router-dom';
import { useCustomModal } from '../../../../hooks/useCustomModal';
import { Button, Table } from 'antd';
import { stringDate } from '../../../../util';
import { formatPrice } from '../../../../util/formatPrice';
import { ModalView } from '../../../uiComponents';
import { ConsignOrderRefundStatus } from '../ConsignmentOrderRefundStatus';
import {
  consignOrderRefundConst,
  consignOrderRefundStatusConst,
} from '../../../../constants/ConsignOrderRefund.const';
import { ConsignOrderRefundTableOptions } from '../ConsignmentOrderRefundOption';
import { ConsignOrderRefundModalBody } from '../ConsignmentOrderRefundModal';

export const ConsignmentOrderRefundTable = ({
  privileges,
  role,
  numberOrder,
}) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [modalTitle, setModalTitle] = useState(null);
  const [modalData, setModalData] = useState({});
  const { catalogId, setModal } = useCustomModal();
  const { consignmentOrderRefundByConsigmentOrder } = useSelector(
    (state) => state.consignmentOrderRefund
  );
  const getConsignmentOrderRefundByConsigmentOrderById = useCallback(() => {
    if (id) {
      dispatch(getConsignmentOrderRefundByOrderId(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    getConsignmentOrderRefundByConsigmentOrderById();
  }, [getConsignmentOrderRefundByConsigmentOrderById]);

  const getStatus = (record) => {
    const status = record.deletedAt
      ? consignOrderRefundStatusConst.CANCELED
      : record.status;
    return <ConsignOrderRefundStatus status={status} />;
  };

  const onDelete = async (id) => {
    await dispatch(deleteConsignmentOrderRefund(id));
    getConsignmentOrderRefundByConsigmentOrderById();
  };

  useEffect(() => {
    if (!modalData) return;

    setModalTitle(
      `${consignOrderRefundConst.header}: ${modalData.refundNumber}`
    );
  }, [modalData]);

  const columns = [
    {
      title: 'Número de Devolucion',
      dataIndex: 'refundNumber',
      key: 'refundNumber',
      render: (refundNumber, record) => (
        <Button
          type="link"
          htmlType="button"
          onClick={() => {
            setModal(record.id);
            setModalData(record);
          }}
        >
          {`DC${refundNumber}`}
        </Button>
      ),
    },
    {
      title: 'Estado',
      key: 'status',
      render: (_, record) => {
        return getStatus(record);
      },
    },
    {
      title: 'Fecha de creación',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (createdAt) => stringDate(createdAt),
    },
    {
      title: 'Fecha de devolucion',
      dataIndex: 'refundAt',
      key: 'refundAt',
      render: (refundAt) => stringDate(refundAt),
    },
    {
      title: 'Total',
      dataIndex: 'total',
      key: 'total',
      render: (total) => `${formatPrice(total || '0')}`,
    },
    {
      title: 'Opciones',
      key: 'actions',
      render: (_, record) => (
        <ConsignOrderRefundTableOptions
          id={record.id}
          action={{
            onDelete: {
              action: onDelete,
              params: [record.id],
            },
          }}
          privileges={privileges}
          status={record.status}
          role={role}
          numberOrder={numberOrder}
          consignmentOrderId={id}
        />
      ),
    },
  ];

  return (
    <>
      <Table
        dataSource={consignmentOrderRefundByConsigmentOrder}
        columns={columns}
        rowKey={(row) => row.id}
        pagination={{
          defaultPageSize: 10,
          pageSizeOptions: [10, 20, 40, 60],
        }}
      />
      <ModalView title={modalTitle} width={900}>
        <ConsignOrderRefundModalBody data={modalData} />
      </ModalView>
    </>
  );
};
